import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { usePagination } from './usePagination';
import "../../css/Pagination.css"
export default function Pagination(props) {
    const {
        onPageChange,
        totalCount,
        siblingCount = 4,
        currentPage,
        pageSize,
    } = props;
    
    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize,
    });

    const firstPage = () => {
        onPageChange(1);
    }
    const lastPages = () => {
        onPageChange(lastPage);
    }
    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };
    const prevTen = () => {
        onPageChange(currentPage - 10);
    }
    const nextTen = () => {
        onPageChange(currentPage + 10);
    }

    const lastPage = (totalCount > 0 && pageSize > 0) ? Math.ceil(totalCount / pageSize) : 1;

    return (
        <div className="paginationWrapper">
            <div className="paginationCopy">
                <Button className="buttons" onClick={firstPage} disabled={currentPage === 1}>First</Button>
                <Button className="buttons" disabled={currentPage <= 10} onClick={prevTen}>Prev 10</Button>
                <Button className="buttons" disabled={currentPage === 1} onClick={onPrevious}>Prev</Button>
                {paginationRange?.map((pageNumber, key, i) => {
                    return (
                        <Button onClick={() => onPageChange(pageNumber)}
                            className={pageNumber === currentPage ? "active" : "inActive"} key={i + key + pageNumber}>{pageNumber}</Button>
                    );
                })}
                <Button className="buttons" disabled={totalCount === 0 || currentPage === lastPage} onClick={onNext}>Next</Button>
                <Button className="buttons" disabled={lastPage - currentPage < 10} onClick={nextTen}>Next 10</Button>
                <Button className="buttons" disabled={totalCount === 0 || currentPage === lastPage} onClick={lastPages}>Last</Button>
                <span className="count">Page {lastPage === 0 ? 0 : currentPage} of {lastPage || 1}</span>
            </div>
        </div>
    )
}